import { ArrowDownTrayIcon as DownloadIcon } from '@heroicons/react/24/outline';
import { useState } from 'react';

import { SecondaryButton } from '@atoms/buttons/SecondaryButton';

import { PayoutsExportDialog } from './PayoutsExportDialog';

export const CreatePayoutsExportButton = () => {
  const [open, setOpen] = useState(false);

  return (
    <div className="flex flex-col gap-4">
      <SecondaryButton
        onClick={() => setOpen(true)}
        data-testid="payouts-export-to-csv"
        className="h-9"
      >
        <DownloadIcon className="size-4 stroke-current" />
        Export
      </SecondaryButton>
      <PayoutsExportDialog open={open} onClose={() => setOpen(false)} />
    </div>
  );
};
